export const getReadyAdditionalObjects = (componentID?: string) => ({
  componentInfo: { componentID },
  attributes: { implementer: 2, version: '8.2.0' },
});
